/**
 * O token (como gravado no localStorage) é do Super Admin fora de qualquer empresa?
 * Não usa decodeJWT: ele limpa o localStorage quando recebe algo que não é string.
 */
function ehTokenBase(tokenGravado) {
    try {
        const payload = JSON.parse(tokenGravado).split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const claims = JSON.parse(window.atob(payload.padEnd(Math.ceil(payload.length / 4) * 4, '='))) || {};
        return claims.super_admin === true && !claims.empresa_id;
    } catch {
        return false;
    }
}

/**
 * Entra no contexto de uma empresa (ou do catálogo) com a resposta de api/selecionar-empresa.
 * O token base do Super Admin é preservado: entrar a partir de outro contexto (ex.: uma aba
 * antiga ou o "voltar" do navegador) não pode trocá-lo pelo token de uma empresa.
 *
 * @param {object} dados - resposta de api/selecionar-empresa ({token, nivel, empresa_id})
 * @param {string} nomeEmpresa - nome mostrado no banner
 * @param {string} destino - rota para onde ir depois
 */
export function entrarNoContextoEmpresa(dados, nomeEmpresa, destino) {
    if (!ehTokenBase(localStorage.getItem("super_admin_base_token"))) {
        const atual = localStorage.getItem("user_token");
        if (ehTokenBase(atual)) {
            localStorage.setItem("super_admin_base_token", atual);
        } else {
            localStorage.removeItem("super_admin_base_token");
        }
    }
    localStorage.setItem("empresa_nome_atual", nomeEmpresa);
    localStorage.setItem("user_token", JSON.stringify(dados.token));
    localStorage.setItem("nivel", dados.nivel || 'Administrador');
    localStorage.setItem("empresa_id", dados.empresa_id);
    window.location.href = destino;
}

/**
 * Sai do contexto de uma empresa (ou do catálogo) e volta ao token base do Super Admin.
 * Sem um token base válido não há como voltar: a sessão é encerrada e o login é pedido de novo.
 *
 * @param {string} destino - rota para onde ir depois (ex.: '/listar-empresas' ou '/catalogo')
 */
export function sairDoContextoEmpresa(destino) {
    const baseToken = localStorage.getItem("super_admin_base_token");
    if (!ehTokenBase(baseToken)) {
        localStorage.clear();
        window.location.href = '/';
        return;
    }
    localStorage.setItem("user_token", baseToken);
    localStorage.removeItem("super_admin_base_token");
    localStorage.removeItem("empresa_nome_atual");
    localStorage.setItem("empresa_id", "");
    window.location.href = destino;
}
